export default [{
  path: 'vehicleAttendance',
  name: 'vehicleAttendance',
  component: function component() {
    return import('@/views/reportManage/vehicleAttendance');
  }
}, {
  path: 'weighbridgeWeighList',
  name: 'weighbridgeWeighList',
  component: function component() {
    return import('@/views/reportManage/weighbridgeWeighList');
  }
}, {
  path: 'weighbridgeCarryList',
  name: 'weighbridgeCarryList',
  component: function component() {
    return import('@/views/reportManage/weighbridgeCarryList');
  }
}, {
  path: 'weighbridgeCarryNewList',
  name: 'weighbridgeCarryNewList',
  component: function component() {
    return import('@/views/reportManage/weighbridgeCarryNewList');
  }
}, {
  //康思创内部使用页面
  path: 'weighbridgeCarryList2',
  name: 'weighbridgeCarryList2',
  component: function component() {
    return import('@/views/reportManage/weighbridgeCarryList2');
  }
}, {
  path: 'weighbridgeSummaryList',
  name: 'weighbridgeSummaryList',
  component: function component() {
    return import('@/views/reportManage/weighbridgeSummaryList');
  }
}, {
  path: 'weighbridgeSummaryNewList',
  name: 'weighbridgeSummaryNewList',
  component: function component() {
    return import('@/views/reportManage/weighbridgeSummaryNewList');
  }
}, {
  path: 'vehicleTransportList',
  name: 'vehicleTransportList',
  component: function component() {
    return import('@/views/transport/list');
  }
},
// {
// 	  path: 'vehicleTransportNumList',
// 	  name: 'vehicleTransportNumList',
// 	  component: () => import('@/views/reportManage/carNumList')
// },
{
  path: 'vehicleTransportOverspeedList',
  name: 'vehicleTransportOverspeedList',
  component: function component() {
    return import('@/views/transport/overspeedList');
  }
}, {
  path: 'overspeedRoadManageList',
  name: 'overspeedRoadManageList',
  component: function component() {
    return import('@/views/transport/overspeedRoadManageList');
  }
}, {
  path: 'overspeedRoadDetail',
  name: 'overspeedRoadDetail',
  component: function component() {
    return import('@/views/transport/overspeedRoadDetail');
  }
}, {
  path: 'overspeedDetail',
  name: 'overspeedDetail',
  component: function component() {
    return import('@/views/transport/overspeedDetail');
  }
}, {
  path: 'overspeedAdd',
  name: 'overspeedAdd',
  component: function component() {
    return import('@/views/transport/overspeedAdd');
  }
}, {
  path: 'weighbridgeWeighImport',
  name: 'weighbridgeWeighImport',
  component: function component() {
    return import('@/views/reportManage/import');
  }
}, {
  path: 'overspeedDetailList',
  name: 'overspeedDetailList',
  component: function component() {
    return import('@/views/transport/overspeedDetailList');
  }
}];